/* ============================================================================
 * LOCALIZAÇÃO PT-PT
 * ----------------------------------------------------------------------------
 * Traduz nomes de países e cidades para Português de Portugal na CAMADA DE
 * EXIBIÇÃO. O backend/BD guardam os nomes no idioma original (ex.: "Spain").
 * Para não quebrar os endpoints que filtram por nome (ex.: /cities/by-country),
 * mantemos o valor INTERNO em inglês e só traduzimos o que o utilizador vê.
 *
 * Importante (TripWizard): nos <select> o `value`/estado continua com o nome
 * original EN; apenas o texto do <option> passa por translateCountry().
 * ========================================================================== */
import { PT_TO_LOCALE } from '../context/localeTranslations';

// ── Países: Inglês → Português de Portugal (242, alinhado com a API) ──────
const COUNTRY_PT = {
  'Afghanistan': 'Afeganistão',
  'Albania': 'Albânia',
  'Algeria': 'Argélia',
  'American Samoa': 'Samoa Americana',
  'Andorra': 'Andorra',
  'Angola': 'Angola',
  'Anguilla': 'Anguila',
  'Antigua and Barbuda': 'Antígua e Barbuda',
  'Argentina': 'Argentina',
  'Armenia': 'Arménia',
  'Aruba': 'Aruba',
  'Australia': 'Austrália',
  'Austria': 'Áustria',
  'Azerbaijan': 'Azerbaijão',
  'Bahamas, The': 'Baamas',
  'Bahrain': 'Barém',
  'Bangladesh': 'Bangladeche',
  'Barbados': 'Barbados',
  'Belarus': 'Bielorrússia',
  'Belgium': 'Bélgica',
  'Belize': 'Belize',
  'Benin': 'Benim',
  'Bermuda': 'Bermudas',
  'Bhutan': 'Butão',
  'Bolivia': 'Bolívia',
  'Bonaire, Sint Eustatius, and Saba': 'Bonaire, Santo Eustáquio e Saba',
  'Bosnia and Herzegovina': 'Bósnia e Herzegovina',
  'Botswana': 'Botsuana',
  'Brazil': 'Brasil',
  'Brunei': 'Brunei',
  'Bulgaria': 'Bulgária',
  'Burkina Faso': 'Burquina Faso',
  'Burma': 'Mianmar',
  'Burundi': 'Burúndi',
  'Cabo Verde': 'Cabo Verde',
  'Cambodia': 'Camboja',
  'Cameroon': 'Camarões',
  'Canada': 'Canadá',
  'Cayman Islands': 'Ilhas Caimão',
  'Central African Republic': 'República Centro-Africana',
  'Chad': 'Chade',
  'Chile': 'Chile',
  'China': 'China',
  'Christmas Island': 'Ilha do Natal',
  'Colombia': 'Colômbia',
  'Comoros': 'Comores',
  'Congo (Brazzaville)': 'Congo (Brazzaville)',
  'Congo (Kinshasa)': 'Congo (Quinxassa)',
  'Cook Islands': 'Ilhas Cook',
  'Costa Rica': 'Costa Rica',
  'Croatia': 'Croácia',
  'Cuba': 'Cuba',
  'Curaçao': 'Curaçau',
  'Cyprus': 'Chipre',
  'Czechia': 'Chéquia',
  'Côte d’Ivoire': 'Costa do Marfim',
  'Denmark': 'Dinamarca',
  'Djibouti': 'Jibuti',
  'Dominica': 'Domínica',
  'Dominican Republic': 'República Dominicana',
  'Ecuador': 'Equador',
  'Egypt': 'Egito',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guiné Equatorial',
  'Eritrea': 'Eritreia',
  'Estonia': 'Estónia',
  'Eswatini': 'Essuatíni',
  'Ethiopia': 'Etiópia',
  'Falkland Islands (Islas Malvinas)': 'Ilhas Falkland (Malvinas)',
  'Faroe Islands': 'Ilhas Feroé',
  'Fiji': 'Fiji',
  'Finland': 'Finlândia',
  'France': 'França',
  'French Guiana': 'Guiana Francesa',
  'French Polynesia': 'Polinésia Francesa',
  'Gabon': 'Gabão',
  'Gambia, The': 'Gâmbia',
  'Gaza Strip': 'Faixa de Gaza',
  'Georgia': 'Geórgia',
  'Germany': 'Alemanha',
  'Ghana': 'Gana',
  'Gibraltar': 'Gibraltar',
  'Greece': 'Grécia',
  'Greenland': 'Gronelândia',
  'Grenada': 'Granada',
  'Guadeloupe': 'Guadalupe',
  'Guam': 'Guame',
  'Guatemala': 'Guatemala',
  'Guernsey': 'Guernesey',
  'Guinea': 'Guiné',
  'Guinea-Bissau': 'Guiné-Bissau',
  'Guyana': 'Guiana',
  'Haiti': 'Haiti',
  'Honduras': 'Honduras',
  'Hong Kong': 'Hong Kong',
  'Hungary': 'Hungria',
  'Iceland': 'Islândia',
  'India': 'Índia',
  'Indonesia': 'Indonésia',
  'Iran': 'Irão',
  'Iraq': 'Iraque',
  'Ireland': 'Irlanda',
  'Isle of Man': 'Ilha de Man',
  'Israel': 'Israel',
  'Italy': 'Itália',
  'Jamaica': 'Jamaica',
  'Japan': 'Japão',
  'Jersey': 'Jérsia',
  'Jordan': 'Jordânia',
  'Kazakhstan': 'Cazaquistão',
  'Kenya': 'Quénia',
  'Kiribati': 'Quiribáti',
  'Korea, North': 'Coreia do Norte',
  'Korea, South': 'Coreia do Sul',
  'Kosovo': 'Kosovo',
  'Kuwait': 'Kuwait',
  'Kyrgyzstan': 'Quirguistão',
  'Laos': 'Laos',
  'Latvia': 'Letónia',
  'Lebanon': 'Líbano',
  'Lesotho': 'Lesoto',
  'Liberia': 'Libéria',
  'Libya': 'Líbia',
  'Liechtenstein': 'Listenstaine',
  'Lithuania': 'Lituânia',
  'Luxembourg': 'Luxemburgo',
  'Macau': 'Macau',
  'Madagascar': 'Madagáscar',
  'Malawi': 'Maláui',
  'Malaysia': 'Malásia',
  'Maldives': 'Maldivas',
  'Mali': 'Mali',
  'Malta': 'Malta',
  'Marshall Islands': 'Ilhas Marshall',
  'Martinique': 'Martinica',
  'Mauritania': 'Mauritânia',
  'Mauritius': 'Maurícia',
  'Mayotte': 'Maiote',
  'Mexico': 'México',
  'Micronesia, Federated States of': 'Estados Federados da Micronésia',
  'Moldova': 'Moldávia',
  'Monaco': 'Mónaco',
  'Mongolia': 'Mongólia',
  'Montenegro': 'Montenegro',
  'Montserrat': 'Monserrate',
  'Morocco': 'Marrocos',
  'Mozambique': 'Moçambique',
  'Namibia': 'Namíbia',
  'Nauru': 'Nauru',
  'Nepal': 'Nepal',
  'Netherlands': 'Países Baixos',
  'New Caledonia': 'Nova Caledónia',
  'New Zealand': 'Nova Zelândia',
  'Nicaragua': 'Nicarágua',
  'Niger': 'Níger',
  'Nigeria': 'Nigéria',
  'Niue': 'Niuê',
  'Norfolk Island': 'Ilha Norfolk',
  'North Macedonia': 'Macedónia do Norte',
  'Northern Mariana Islands': 'Ilhas Marianas do Norte',
  'Norway': 'Noruega',
  'Oman': 'Omã',
  'Pakistan': 'Paquistão',
  'Palau': 'Palau',
  'Panama': 'Panamá',
  'Papua New Guinea': 'Papua-Nova Guiné',
  'Paraguay': 'Paraguai',
  'Peru': 'Peru',
  'Philippines': 'Filipinas',
  'Pitcairn Islands': 'Ilhas Pitcairn',
  'Poland': 'Polónia',
  'Portugal': 'Portugal',
  'Puerto Rico': 'Porto Rico',
  'Qatar': 'Catar',
  'Reunion': 'Reunião',
  'Romania': 'Roménia',
  'Russia': 'Rússia',
  'Rwanda': 'Ruanda',
  'Saint Barthelemy': 'São Bartolomeu',
  'Saint Helena, Ascension, and Tristan da Cunha': 'Santa Helena, Ascensão e Tristão da Cunha',
  'Saint Kitts and Nevis': 'São Cristóvão e Neves',
  'Saint Lucia': 'Santa Lúcia',
  'Saint Martin': 'São Martinho',
  'Saint Pierre and Miquelon': 'São Pedro e Miquelão',
  'Saint Vincent and the Grenadines': 'São Vicente e Granadinas',
  'Samoa': 'Samoa',
  'San Marino': 'São Marinho',
  'Sao Tome and Principe': 'São Tomé e Príncipe',
  'Saudi Arabia': 'Arábia Saudita',
  'Senegal': 'Senegal',
  'Serbia': 'Sérvia',
  'Seychelles': 'Seicheles',
  'Sierra Leone': 'Serra Leoa',
  'Singapore': 'Singapura',
  'Sint Maarten': 'São Martinho (Sint Maarten)',
  'Slovakia': 'Eslováquia',
  'Slovenia': 'Eslovénia',
  'Solomon Islands': 'Ilhas Salomão',
  'Somalia': 'Somália',
  'South Africa': 'África do Sul',
  'South Georgia And South Sandwich Islands': 'Ilhas Geórgia do Sul e Sandwich do Sul',
  'South Georgia and South Sandwich Islands': 'Ilhas Geórgia do Sul e Sandwich do Sul',
  'South Sudan': 'Sudão do Sul',
  'Spain': 'Espanha',
  'Sri Lanka': 'Sri Lanca',
  'Sudan': 'Sudão',
  'Suriname': 'Suriname',
  'Svalbard': 'Svalbard',
  'Sweden': 'Suécia',
  'Switzerland': 'Suíça',
  'Syria': 'Síria',
  'Taiwan': 'Taiwan',
  'Tajikistan': 'Tajiquistão',
  'Tanzania': 'Tanzânia',
  'Thailand': 'Tailândia',
  'Timor-Leste': 'Timor-Leste',
  'Togo': 'Togo',
  'Tonga': 'Tonga',
  'Trinidad and Tobago': 'Trindade e Tobago',
  'Tunisia': 'Tunísia',
  'Turkey': 'Turquia',
  'Turkmenistan': 'Turquemenistão',
  'Turks and Caicos Islands': 'Ilhas Turcas e Caicos',
  'Tuvalu': 'Tuvalu',
  'U.S. Virgin Islands': 'Ilhas Virgens dos Estados Unidos',
  'Uganda': 'Uganda',
  'Ukraine': 'Ucrânia',
  'United Arab Emirates': 'Emirados Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States': 'Estados Unidos',
  'Uruguay': 'Uruguai',
  'Uzbekistan': 'Uzbequistão',
  'Vanuatu': 'Vanuatu',
  'Vatican City': 'Vaticano',
  'Venezuela': 'Venezuela',
  'Vietnam': 'Vietname',
  'Virgin Islands, British': 'Ilhas Virgens Britânicas',
  'Wallis and Futuna': 'Wallis e Futuna',
  'West Bank': 'Cisjordânia',
  'Yemen': 'Iémen',
  'Zambia': 'Zâmbia',
  'Zimbabwe': 'Zimbabué',
};

// ── Cidades com tradução comum em PT-PT (as restantes mantêm o original,
//    como é natural em português — ex.: "Bangkok" é igual). ────────────────
const CITY_PT = {
  'Lisbon': 'Lisboa',
  'Porto': 'Porto',
  'Aveiro': 'Aveiro',
  'Sintra': 'Sintra',
  'Cascais': 'Cascais',
  'Coimbra': 'Coimbra',
  'Braga': 'Braga',
  'Faro': 'Faro',
  'Funchal': 'Funchal',
  'Ponta Delgada': 'Ponta Delgada',
  'Madrid': 'Madrid',
  'Barcelona': 'Barcelona',
  'Seville': 'Sevilha',
  'Valencia': 'Valência',
  'Malaga': 'Málaga',
  'Cordoba': 'Córdova',
  'Bilbao': 'Bilbau',
  'Zaragoza': 'Saragoça',
  'Alicante': 'Alicante',
  'Palma': 'Palma',
  'Tenerife': 'Tenerife',
  'Gran Canaria': 'Grã-Canária',
  'Paris': 'Paris',
  'Marseille': 'Marselha',
  'Lyon': 'Lião',
  'Bordeaux': 'Bordéus',
  'Toulouse': 'Tolosa',
  'Strasbourg': 'Estrasburgo',
  'Rome': 'Roma',
  'Milan': 'Milão',
  'Venice': 'Veneza',
  'Naples': 'Nápoles',
  'Florence': 'Florença',
  'Turin': 'Turim',
  'Genoa': 'Génova',
  'London': 'Londres',
  'Edinburgh': 'Edimburgo',
  'Glasgow': 'Glásgua',
  'Prague': 'Praga',
  'Vienna': 'Viena',
  'Warsaw': 'Varsóvia',
  'Krakow': 'Cracóvia',
  'Munich': 'Munique',
  'Cologne': 'Colónia',
  'Frankfurt': 'Francoforte',
  'Hamburg': 'Hamburgo',
  'Berlin': 'Berlim',
  'Amsterdam': 'Amesterdão',
  'Rotterdam': 'Roterdão',
  'The Hague': 'Haia',
  'Brussels': 'Bruxelas',
  'Antwerp': 'Antuérpia',
  'Ghent': 'Gante',
  'Copenhagen': 'Copenhaga',
  'Stockholm': 'Estocolmo',
  'Helsinki': 'Helsínquia',
  'Athens': 'Atenas',
  'Moscow': 'Moscovo',
  'Saint Petersburg': 'São Petersburgo',
  'Beijing': 'Pequim',
  'Shanghai': 'Xangai',
  'Guangzhou': 'Cantão',
  'Tokyo': 'Tóquio',
  'Kyoto': 'Quioto',
  'Seoul': 'Seul',
  'Mexico City': 'Cidade do México',
  'Bogota': 'Bogotá',
  'New York': 'Nova Iorque',
  'Montreal': 'Montreal',
  'Cape Town': 'Cidade do Cabo',
  'Johannesburg': 'Joanesburgo',
  'Nairobi': 'Nairóbi',
  'Accra': 'Acra',
  'Dakar': 'Dacar',
  'Tunis': 'Tunes',
  'Algiers': 'Argel',
  'Tripoli': 'Trípoli',
  'Amman': 'Amã',
  'Jerusalem': 'Jerusalém',
  'Beirut': 'Beirute',
  'Baghdad': 'Bagdade',
  'Tehran': 'Teerão',
  'Riyadh': 'Riade',
  'Abu Dhabi': 'Abu Dabi',
  'Istanbul': 'Istambul',
  'Ankara': 'Ancara',
  'Kyiv': 'Kiev',
  'Minsk': 'Minsque',
  'Bucharest': 'Bucareste',
  'Budapest': 'Budapeste',
  'Belgrade': 'Belgrado',
  'Sofia': 'Sófia',
  'Zagreb': 'Zagrebe',
  'Ljubljana': 'Liubliana',
  'Skopje': 'Escópia',
  'Zurich': 'Zurique',
  'Geneva': 'Genebra',
  'Basel': 'Basileia',
  'Bern': 'Berna',
  'Salzburg': 'Salisburgo',
  'Marrakesh': 'Marraquexe',
  'Casablanca': 'Casablanca',
  'Brasilia': 'Brasília',
  'Rio de Janeiro': 'Rio de Janeiro',
  'Sao Paulo': 'São Paulo',
  'Santiago': 'Santiago',
};

// Country/city names shown in the destination wizard are localized for all
// interface languages, while their option values stay canonical English.
// These city exonyms cover the most common catalogue entries; any other
// localized city name can still be found through the wizard's locale-aware
// place search.
const CITY_LOCALE_NAMES = Object.freeze({
  Lisbon: { es: 'Lisboa', fr: 'Lisbonne', de: 'Lissabon', zh: '里斯本', it: 'Lisbona' },
  Porto: { es: 'Oporto', fr: 'Porto', de: 'Porto', zh: '波尔图', it: 'Porto' },
  Seville: { es: 'Sevilla', fr: 'Séville', de: 'Sevilla', zh: '塞维利亚', it: 'Siviglia' },
  Valencia: { es: 'Valencia', fr: 'Valence', de: 'Valencia', zh: '瓦伦西亚', it: 'Valencia' },
  Malaga: { es: 'Málaga', fr: 'Malaga', de: 'Malaga', zh: '马拉加', it: 'Malaga' },
  Cordoba: { es: 'Córdoba', fr: 'Cordoue', de: 'Córdoba', zh: '科尔多瓦', it: 'Cordova' },
  Bilbao: { es: 'Bilbao', fr: 'Bilbao', de: 'Bilbao', zh: '毕尔巴鄂', it: 'Bilbao' },
  Zaragoza: { es: 'Zaragoza', fr: 'Saragosse', de: 'Saragossa', zh: '萨拉戈萨', it: 'Saragozza' },
  'Gran Canaria': { es: 'Gran Canaria', fr: 'Grande Canarie', de: 'Gran Canaria', zh: '大加那利岛', it: 'Gran Canaria' },
  Rome: { es: 'Roma', fr: 'Rome', de: 'Rom', zh: '罗马', it: 'Roma' },
  Milan: { es: 'Milán', fr: 'Milan', de: 'Mailand', zh: '米兰', it: 'Milano' },
  Venice: { es: 'Venecia', fr: 'Venise', de: 'Venedig', zh: '威尼斯', it: 'Venezia' },
  Naples: { es: 'Nápoles', fr: 'Naples', de: 'Neapel', zh: '那不勒斯', it: 'Napoli' },
  Florence: { es: 'Florencia', fr: 'Florence', de: 'Florenz', zh: '佛罗伦萨', it: 'Firenze' },
  Turin: { es: 'Turín', fr: 'Turin', de: 'Turin', zh: '都灵', it: 'Torino' },
  Genoa: { es: 'Génova', fr: 'Gênes', de: 'Genua', zh: '热那亚', it: 'Genova' },
  London: { es: 'Londres', fr: 'Londres', de: 'London', zh: '伦敦', it: 'Londra' },
  Edinburgh: { es: 'Edimburgo', fr: 'Édimbourg', de: 'Edinburgh', zh: '爱丁堡', it: 'Edimburgo' },
  Glasgow: { es: 'Glasgow', fr: 'Glasgow', de: 'Glasgow', zh: '格拉斯哥', it: 'Glasgow' },
  Prague: { es: 'Praga', fr: 'Prague', de: 'Prag', zh: '布拉格', it: 'Praga' },
  Vienna: { es: 'Viena', fr: 'Vienne', de: 'Wien', zh: '维也纳', it: 'Vienna' },
  Warsaw: { es: 'Varsovia', fr: 'Varsovie', de: 'Warschau', zh: '华沙', it: 'Varsavia' },
  Krakow: { es: 'Cracovia', fr: 'Cracovie', de: 'Krakau', zh: '克拉科夫', it: 'Cracovia' },
  Munich: { es: 'Múnich', fr: 'Munich', de: 'München', zh: '慕尼黑', it: 'Monaco di Baviera' },
  Cologne: { es: 'Colonia', fr: 'Cologne', de: 'Köln', zh: '科隆', it: 'Colonia' },
  Frankfurt: { es: 'Fráncfort', fr: 'Francfort', de: 'Frankfurt am Main', zh: '法兰克福', it: 'Francoforte' },
  Hamburg: { es: 'Hamburgo', fr: 'Hambourg', de: 'Hamburg', zh: '汉堡', it: 'Amburgo' },
  Berlin: { es: 'Berlín', fr: 'Berlin', de: 'Berlin', zh: '柏林', it: 'Berlino' },
  Amsterdam: { es: 'Ámsterdam', fr: 'Amsterdam', de: 'Amsterdam', zh: '阿姆斯特丹', it: 'Amsterdam' },
  Rotterdam: { es: 'Róterdam', fr: 'Rotterdam', de: 'Rotterdam', zh: '鹿特丹', it: 'Rotterdam' },
  'The Hague': { es: 'La Haya', fr: 'La Haye', de: 'Den Haag', zh: '海牙', it: 'L’Aia' },
  Brussels: { es: 'Bruselas', fr: 'Bruxelles', de: 'Brüssel', zh: '布鲁塞尔', it: 'Bruxelles' },
  Antwerp: { es: 'Amberes', fr: 'Anvers', de: 'Antwerpen', zh: '安特卫普', it: 'Anversa' },
  Ghent: { es: 'Gante', fr: 'Gand', de: 'Gent', zh: '根特', it: 'Gand' },
  Copenhagen: { es: 'Copenhague', fr: 'Copenhague', de: 'Kopenhagen', zh: '哥本哈根', it: 'Copenaghen' },
  Stockholm: { es: 'Estocolmo', fr: 'Stockholm', de: 'Stockholm', zh: '斯德哥尔摩', it: 'Stoccolma' },
  Helsinki: { es: 'Helsinki', fr: 'Helsinki', de: 'Helsinki', zh: '赫尔辛基', it: 'Helsinki' },
  Athens: { es: 'Atenas', fr: 'Athènes', de: 'Athen', zh: '雅典', it: 'Atene' },
  Moscow: { es: 'Moscú', fr: 'Moscou', de: 'Moskau', zh: '莫斯科', it: 'Mosca' },
  'Saint Petersburg': { es: 'San Petersburgo', fr: 'Saint-Pétersbourg', de: 'Sankt Petersburg', zh: '圣彼得堡', it: 'San Pietroburgo' },
  Beijing: { es: 'Pekín', fr: 'Pékin', de: 'Peking', zh: '北京', it: 'Pechino' },
  Shanghai: { es: 'Shanghái', fr: 'Shanghai', de: 'Shanghai', zh: '上海', it: 'Shanghai' },
  Guangzhou: { es: 'Cantón', fr: 'Canton', de: 'Kanton', zh: '广州', it: 'Canton' },
  Tokyo: { es: 'Tokio', fr: 'Tokyo', de: 'Tokio', zh: '东京', it: 'Tokyo' },
  Kyoto: { es: 'Kioto', fr: 'Kyoto', de: 'Kyoto', zh: '京都', it: 'Kyoto' },
  Seoul: { es: 'Seúl', fr: 'Séoul', de: 'Seoul', zh: '首尔', it: 'Seul' },
  'Mexico City': { es: 'Ciudad de México', fr: 'Mexico', de: 'Mexiko-Stadt', zh: '墨西哥城', it: 'Città del Messico' },
  Bogota: { es: 'Bogotá', fr: 'Bogota', de: 'Bogota', zh: '波哥大', it: 'Bogotà' },
  'New York': { es: 'Nueva York', fr: 'New York', de: 'New York', zh: '纽约', it: 'New York' },
  Montreal: { es: 'Montreal', fr: 'Montréal', de: 'Montreal', zh: '蒙特利尔', it: 'Montréal' },
  'Cape Town': { es: 'Ciudad del Cabo', fr: 'Le Cap', de: 'Kapstadt', zh: '开普敦', it: 'Città del Capo' },
  Johannesburg: { es: 'Johannesburgo', fr: 'Johannesburg', de: 'Johannesburg', zh: '约翰内斯堡', it: 'Johannesburg' },
  Nairobi: { es: 'Nairobi', fr: 'Nairobi', de: 'Nairobi', zh: '内罗毕', it: 'Nairobi' },
  Accra: { es: 'Acra', fr: 'Accra', de: 'Accra', zh: '阿克拉', it: 'Accra' },
  Dakar: { es: 'Dakar', fr: 'Dakar', de: 'Dakar', zh: '达喀尔', it: 'Dakar' },
  Tunis: { es: 'Túnez', fr: 'Tunis', de: 'Tunis', zh: '突尼斯', it: 'Tunisi' },
  Algiers: { es: 'Argel', fr: 'Alger', de: 'Algier', zh: '阿尔及尔', it: 'Algeri' },
  Tripoli: { es: 'Trípoli', fr: 'Tripoli', de: 'Tripolis', zh: '的黎波里', it: 'Tripoli' },
  Amman: { es: 'Amán', fr: 'Amman', de: 'Amman', zh: '安曼', it: 'Amman' },
  Jerusalem: { es: 'Jerusalén', fr: 'Jérusalem', de: 'Jerusalem', zh: '耶路撒冷', it: 'Gerusalemme' },
  Beirut: { es: 'Beirut', fr: 'Beyrouth', de: 'Beirut', zh: '贝鲁特', it: 'Beirut' },
  Baghdad: { es: 'Bagdad', fr: 'Bagdad', de: 'Bagdad', zh: '巴格达', it: 'Baghdad' },
  Tehran: { es: 'Teherán', fr: 'Téhéran', de: 'Teheran', zh: '德黑兰', it: 'Teheran' },
  Riyadh: { es: 'Riad', fr: 'Riyad', de: 'Riad', zh: '利雅得', it: 'Riad' },
  'Abu Dhabi': { es: 'Abu Dabi', fr: 'Abou Dabi', de: 'Abu Dhabi', zh: '阿布扎比', it: 'Abu Dhabi' },
  Istanbul: { es: 'Estambul', fr: 'Istanbul', de: 'Istanbul', zh: '伊斯坦布尔', it: 'Istanbul' },
  Ankara: { es: 'Ankara', fr: 'Ankara', de: 'Ankara', zh: '安卡拉', it: 'Ankara' },
  Kyiv: { es: 'Kiev', fr: 'Kyiv', de: 'Kiew', zh: '基辅', it: 'Kiev' },
  Minsk: { es: 'Minsk', fr: 'Minsk', de: 'Minsk', zh: '明斯克', it: 'Minsk' },
  Bucharest: { es: 'Bucarest', fr: 'Bucarest', de: 'Bukarest', zh: '布加勒斯特', it: 'Bucarest' },
  Budapest: { es: 'Budapest', fr: 'Budapest', de: 'Budapest', zh: '布达佩斯', it: 'Budapest' },
  Belgrade: { es: 'Belgrado', fr: 'Belgrade', de: 'Belgrad', zh: '贝尔格莱德', it: 'Belgrado' },
  Sofia: { es: 'Sofía', fr: 'Sofia', de: 'Sofia', zh: '索非亚', it: 'Sofia' },
  Zagreb: { es: 'Zagreb', fr: 'Zagreb', de: 'Zagreb', zh: '萨格勒布', it: 'Zagabria' },
  Ljubljana: { es: 'Liubliana', fr: 'Ljubljana', de: 'Laibach', zh: '卢布尔雅那', it: 'Lubiana' },
  Skopje: { es: 'Skopie', fr: 'Skopje', de: 'Skopje', zh: '斯科普里', it: 'Skopje' },
  Zurich: { es: 'Zúrich', fr: 'Zurich', de: 'Zürich', zh: '苏黎世', it: 'Zurigo' },
  Geneva: { es: 'Ginebra', fr: 'Genève', de: 'Genf', zh: '日内瓦', it: 'Ginevra' },
  Basel: { es: 'Basilea', fr: 'Bâle', de: 'Basel', zh: '巴塞尔', it: 'Basilea' },
  Bern: { es: 'Berna', fr: 'Berne', de: 'Bern', zh: '伯尔尼', it: 'Berna' },
  Salzburg: { es: 'Salzburgo', fr: 'Salzbourg', de: 'Salzburg', zh: '萨尔茨堡', it: 'Salisburgo' },
  Marrakesh: { es: 'Marrakech', fr: 'Marrakech', de: 'Marrakesch', zh: '马拉喀什', it: 'Marrakech' },
  Brasilia: { es: 'Brasilia', fr: 'Brasília', de: 'Brasília', zh: '巴西利亚', it: 'Brasilia' },
  'Rio de Janeiro': { es: 'Río de Janeiro', fr: 'Rio de Janeiro', de: 'Rio de Janeiro', zh: '里约热内卢', it: 'Rio de Janeiro' },
  'Sao Paulo': { es: 'São Paulo', fr: 'São Paulo', de: 'São Paulo', zh: '圣保罗', it: 'San Paolo' },
});

// The API keeps the canonical place names in English.  Keep reverse indexes
// here as well so a Portuguese search/filter can be translated back to the
// value expected by the API without changing what is shown to the user.
const normalizePlaceKey = (value) => String(value || '')
  .normalize('NFD')
  .replace(/\p{Diacritic}/gu, '')
  .trim()
  .toLocaleLowerCase('pt-PT');

const COUNTRY_EN_BY_LOCALIZED_NAME = Object.fromEntries(
  Object.entries(COUNTRY_PT).flatMap(([english, portuguese]) => [
    [normalizePlaceKey(english), english],
    [normalizePlaceKey(portuguese), english],
    ...Object.values(PT_TO_LOCALE).map((translations) => [
      normalizePlaceKey(translations[portuguese]), english,
    ]),
  ]).filter(([name]) => name),
);
const CITY_EN_BY_LOCALIZED_NAME = Object.fromEntries(
  Object.entries(CITY_PT).flatMap(([english, portuguese]) => [
    [normalizePlaceKey(english), english],
    [normalizePlaceKey(portuguese), english],
    ...Object.values(CITY_LOCALE_NAMES[english] || {}).map((localized) => [
      normalizePlaceKey(localized), english,
    ]),
  ]).filter(([name]) => name),
);

const COUNTRY_EN_BY_PT = Object.fromEntries(
  Object.entries(COUNTRY_PT).map(([english, portuguese]) => [normalizePlaceKey(portuguese), english]),
);
const CITY_EN_BY_PT = Object.fromEntries(
  Object.entries(CITY_PT).map(([english, portuguese]) => [normalizePlaceKey(portuguese), english]),
);

/**
 * Traduz um nome de país (EN) para Português de Portugal.
 * Se não houver tradução, devolve o original.
 */
export const translateCountry = (name) => {
  if (!name || typeof name !== 'string') return name || '';
  return COUNTRY_PT[name] || name;
};

/**
 * Traduz um nome de cidade para Português de Portugal (se existir
 * tradução comum). Devolve o original caso contrário.
 */
export const translateCity = (name) => {
  if (!name || typeof name !== 'string') return name || '';
  return CITY_PT[name] || name;
};

/** Return the canonical English country name used by the API. */
export const toEnglishCountry = (name) => {
  if (!name || typeof name !== 'string') return name || '';
  return COUNTRY_EN_BY_LOCALIZED_NAME[normalizePlaceKey(name)]
    || COUNTRY_EN_BY_PT[normalizePlaceKey(name)]
    || name;
};

/** Return the canonical English city name used by the API. */
export const toEnglishCity = (name) => {
  if (!name || typeof name !== 'string') return name || '';
  return CITY_EN_BY_LOCALIZED_NAME[normalizePlaceKey(name)]
    || CITY_EN_BY_PT[normalizePlaceKey(name)]
    || name;
};

const uniquePlaceNames = (values) => [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];

/** Search aliases for a canonical API country name, including supported UI locales. */
export const getCountrySearchTerms = (name) => {
  const canonical = toEnglishCountry(name);
  const portuguese = COUNTRY_PT[canonical];
  const localizedNames = portuguese
    ? Object.values(PT_TO_LOCALE).map((translations) => translations[portuguese])
    : [];
  return uniquePlaceNames([canonical, portuguese, ...localizedNames]);
};

/** Search aliases for a canonical city name, including common local exonyms. */
export const getCitySearchTerms = (name) => {
  const canonical = toEnglishCity(name);
  return uniquePlaceNames([
    canonical,
    CITY_PT[canonical],
    ...Object.values(CITY_LOCALE_NAMES[canonical] || {}),
  ]);
};

/** Localize country and common city names for the trip destination wizard. */
export const formatWizardPlace = (raw, language = 'pt') => {
  if (!raw || typeof raw !== 'string') return raw || '';
  return raw.split(',').map((part) => {
    const value = part.trim();
    if (!value) return '';
    const country = toEnglishCountry(value);
    if (COUNTRY_PT[country]) {
      if (language === 'pt') return COUNTRY_PT[country];
      if (language === 'en') return country;
      return String(PT_TO_LOCALE[language]?.[COUNTRY_PT[country]] || country).trim();
    }
    const city = toEnglishCity(value);
    if (CITY_PT[city]) {
      if (language === 'pt') return CITY_PT[city];
      if (language === 'en') return city;
      return CITY_LOCALE_NAMES[city]?.[language] || city;
    }
    return value;
  }).filter(Boolean).join(', ');
};

/**
 * Traduz uma string composta "Cidade, País" (ou só um deles) exibida
 * nos cards/detalhes, mantendo o formato e traduzindo cada parte.
 * Ex.: "Seville, Spain" → "Sevilha, Espanha"
 */
export const translatePlace = (raw) => {
  if (!raw || typeof raw !== 'string') return raw || '';
  return raw
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const city = translateCity(part);
      if (city !== part) return city;
      const country = translateCountry(part);
      return country !== part ? country : part;
    })
    .join(', ');
};

/**
 * Format a place for display while preserving the API's canonical stored
 * values. The interactive map passes its active language so Portuguese place
 * names are shown in PT without changing the values used by API filters.
 */
export const formatPlace = (raw, language = 'pt') => {
  if (!raw || typeof raw !== 'string') return raw || '';
  if (language !== 'pt') {
    return raw
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean)
      .map((part) => toEnglishCity(toEnglishCountry(part)))
      .join(', ');
  }
  return translatePlace(raw);
};

/**
 * Traduz um array de nomes (países ou cidades) mantendo a ordem.
 */
export const translateList = (list) =>
  Array.isArray(list) ? list.map((item) => translatePlace(String(item))) : list;

/**
 * Devuelve o nome PT-PT para exibição num <select> mas preserva o valor
 * interno. Uso: `<option value={original}>{ptLabel(original)}</option>`.
 */
export const ptLabel = (name) => translateCountry(name);

// Exposed for the global language layer so the English interface can also
// translate the Portuguese labels rendered by profile, map and destination
// components. Internal API values remain unchanged.
export { COUNTRY_PT, CITY_PT };
